import * as React from 'react'
import * as classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

import * as Style from './style.css'

export interface IProps
  extends Omit<React.ComponentPropsWithoutRef<'select'>, 'type' | 'className'> {
  withIcon?: boolean
  isError?: boolean
}

export const InputSelect = React.forwardRef<HTMLSelectElement, IProps>(
  ({ withIcon, isError, ...props }, ref) => (
    <span className={Style.InputSelectWrapper}>
      <select
        className={classNames({
          [Style.InputSelect]: true,
          [Style.InputSelectError]: isError,
        })}
        {...props}
        ref={ref}
      >
        {props.children}
      </select>
      {withIcon && (
        <FontAwesomeIcon
          icon={faChevronDown}
          className={Style.InputSelectIcon}
        />
      )}
    </span>
  ),
)
